import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Typography, IconButton, Box, Tooltip } from '@material-ui/core';
import InnerContent from '../../../components/PageStructure/InnerContent/InnerContent';

import AlertBox from '../../common/AlertBox/AlertBox';
import PageContent from './../../../components/PageStructure/PageContent/PageContent';
import PageHeader from './../../../components/PageStructure/PageHeader/PageHeader';
import Spinner from './../../../components/common/Spinner/Spinner';
import StatCounter from '../../common/StatCounter/StatCounter';
import { actionTypes } from './../../../settings/constants';
import { VisitActualPropType, VisitActualPatientPropType } from './../../../propTypes/entities/visitActual';

import VisitActualForm from './../Form/VisitActualForm';
import globals from '../../../globals/communityGlobals';
import { paperStyle } from '../../../theme/AllocateBaseTheme';

import { formatNhs } from '../../../utils/helpers';

const locale = globals.getArea('visitActuals');

class VisitActualEdit extends React.Component {
  componentDidMount() {
    this.props.getVisitActual(this.props.match.params.visitActualId);
  }

  convertMinutes = value => ({
    hours: Math.floor(value / 60),
    minutes: value - Math.floor(value / 60) * 60,
  });

  render() {
    const {
      isFetching,
      visitActual,
      submitAction,
      goBack,
      isAllocator,
      match,
      patient,
      failureMessage,
      dismissErrors,
      activityTime,
      visitDuration,
      updateVisitTime,
      addActivityTime,
      enableIntegrationMode,
      externalProviderType,
    } = this.props;

    return (
      <PageContent pageTitle={locale.getMsg('editVisitActual')}>
        <div className="flex-page-content content-wrapper">
          <PageHeader>
            <Box className="title-section" display="flex" alignItems="center" px={2} py={1}>
              <Box>
                <Tooltip title={locale.getMsg('back')}>
                  <IconButton
                    className="back-btn"
                    aria-label="back"
                    size="small"
                    color="primary"
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box flexGrow={1}>
                <Typography variant="h3"> {locale.getMsg('editVisitActual')}</Typography>
              </Box>
            </Box>
          </PageHeader>

          {/* <PageHeader>
            <div className="left-items back-nav">
              <IconButton
                iconClassName="allocateIcons"
                style={{ position: 'absolute', left: 0, top: '9px' }}
                tooltip={locale.getMsg('back')}
                onClick={() => goBack()}
              >
                &#xE5C4;
              </IconButton>
              <h1 className="sub" type="title">
                {locale.getMsg('editVisitActual')}
              </h1>
              <div>
                {patient ? (
                  `${patient.forename} ${patient.surname} -
                ${locale.getMsg('nhsNumber')}: ${formatNhs(patient.nhsNumber)}`
                ) : (
                  <span />
                )}
              </div>
            </div>
            <div className="right-items">
              <StatCounter value={this.convertMinutes(visitDuration)} text={locale.getMsg('visitDuration')} />
              <StatCounter value={this.convertMinutes(activityTime)} text={locale.getMsg('totalActivityTime')} />
            </div>
          </PageHeader> */}
          <InnerContent isBorderless>
            <div className="full-page">
              <Box className="visit-actuals-activity-info">
                <Box
                  className="filter-section"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                  px={2}
                  py={1}
                >
                  <Box>
                    {patient ? (
                      <div>
                        <span>
                          {patient.forename} {patient.surname}
                        </span>
                        -
                        <span>
                          {locale.getMsg('nhsNumber')}: {formatNhs(patient.nhsNumber)}
                        </span>
                      </div>
                    ) : (
                      <span />
                    )}
                  </Box>
                  <Box display="flex" flexDirection="row" className="right-items">
                    <StatCounter text={locale.getMsg('visitDuration')} value={this.convertMinutes(visitDuration)} />
                    <StatCounter text={locale.getMsg('totalActivityTime')} value={this.convertMinutes(activityTime)} />
                  </Box>
                </Box>
              </Box>

              <Box className="visit-actuals-page" p={2}>
                <Paper style={paperStyle}>
                  <AlertBox type="notification" content={failureMessage} onClick={dismissErrors} />
                  {isFetching || !visitActual ? (
                    <Spinner />
                  ) : (
                    <VisitActualForm
                      visitActualId={match.params.visitActualId}
                      isAllocator={isAllocator}
                      visitActual={visitActual}
                      actionType={actionTypes.EDIT}
                      submitAction={submitAction}
                      updateVisitTime={updateVisitTime}
                      addActivityTime={addActivityTime}
                      navigate={goBack}
                      enableIntegrationMode={enableIntegrationMode}
                      externalProviderType={externalProviderType}
                    />
                  )}
                </Paper>
              </Box>
            </div>
          </InnerContent>
        </div>
      </PageContent>
    );
  }
}

VisitActualEdit.defaultProps = {
  visitActual: null,
  patient: null,
  failureMessage: '',
};

VisitActualEdit.propTypes = {
  isAllocator: PropTypes.bool.isRequired,
  visitActual: VisitActualPropType,
  patient: VisitActualPatientPropType,
  isFetching: PropTypes.bool.isRequired,
  getVisitActual: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      visitActualId: PropTypes.string.isRequired,
    }),
  }).isRequired,
  submitAction: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  failureMessage: PropTypes.string.isRequired,
  dismissErrors: PropTypes.func.isRequired,
  updateVisitTime: PropTypes.func.isRequired,
  addActivityTime: PropTypes.func.isRequired,
  activityTime: PropTypes.number.isRequired,
  visitDuration: PropTypes.number.isRequired,
  enableIntegrationMode: PropTypes.bool.isRequired,
};

export default withRouter(VisitActualEdit);
